VLW.PIXIAPP   = class  extends VLW.classBase {
	constructor() {
		super();
		
		this.app        = new PIXI.Application({backgroundColor:0xffffff,preserveDrawingBuffer: true, autoStart: true, resolution:  window.devicePixelRatio ||  1, width: "100%", height: "100%", antialias: true, autoResize: true}); // append the renderer view
		this.aToRender  = [];
		this._renderable = true;
		this.app.stop();
		this.app.view.classList.add("_canvasBackground");
		document.body.appendChild(this.app.view);
		this.onResize();
		window.addEventListener("resize", this.onResize);
		this.aToRender.push(new VLW.PIXIAPP_INTRO());
		this.app.ticker.add(this.render);
		this.app.ticker.start();
		this.app.ticker.speed = .2;
		this.zIndex = 0;
	}
	addChild(elt,zIndex=null){
		elt.zIndex =(zIndex || this.zIndex++);
		this.app.stage.addChild(elt);
		this.app.stage.children.sort((itemA, itemB) => itemA.zIndex - itemB.zIndex);
		
		
	}
	set renderable(render){
		//console.log("%c		set renderable	","background-color:blue",render,this._renderable);
		if(render!==this.renderable) {
			//console.log("%c		","background-color:#B36D35");
			this._renderable = render;
			(this._renderable) ? this.app.ticker.start() : this.app.ticker.stop();
			//debugger;
		}
	}
	get renderable(){
		return this._renderable;
	}

	render() {
		//document.querySelector("._debug").innerHTML = Math.round(this.app.ticker.FPS);
		//console.log("%c		","background-color:#B36D35");
		//console.log("%c		","background-color:#B36D35");
		//if(VLW.PIXIAPP.renderable) {
			//let _now = new Date().getTime();
			//if (_now - this.dateRender >= 14) {
				this.aToRender = this.aToRender.filter(elt => elt.renderable === true);
				this.aToRender.map((elt) => elt.render());
				//this.dateRender = _now;
				//this.app.render();
			//}
		//}
		//requestAnimationFrame(this.render);
	}

	onResize() {
		clearTimeout(this.idOut1);
		this.idOut1 = setTimeout(this.doResize, 100);
	}

	doResize() {
		
		this.app.renderer.resize(windowSize.width, windowSize.height);
		this.aToRender.map((elt) => {
			elt.resize && elt.resize();
		});

	}
}
const PIXIAPP = new VLW.PIXIAPP();